<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 27/9/2020
  -->

<script>
import CommonObject from "@shared/CommonObject";

import {userTimezone} from "@/utils/helpers.js";
import BaseMixinComponent from "@/core/components/BaseMixinComponent.vue";

export default {
	name: "BaseComponent",
	extends: BaseMixinComponent,
	props: {
		analyticsProps: Object,
		dataManagerProp: {default: () => CommonObject.dataManager},
		isTab: Boolean,
	},


	inject: {'registerTab': {default: () => {}}, 'unregisterTab': {default: () => {}}},


	created(){
		this.tryRegisterTab()
	},

	mounted() {
	},

	beforeUnmount(){
		this.tryUnregisterTab()
	},

	methods: {



		async trackEvent(eventName, params = {}){
			return this.$analyticManager.trackEvent(eventName, {...(this.analyticsPropsMethod() || {}), ...params})
		},

		analyticsPropsMethod() {
			let obj = {
				...(this.analyticsProps || {}),
				...this.analyticsPropsInternal()
			}
			if (Object.keys(obj).length) {
				return obj
			}
			return null
		},

		analyticsPropsInternal() {
			return {}
		},

		emitWithThis(methodName, ...args){
			return this.$emit(methodName, ...args, this)
		},

		tryRegisterTab() {
			if (this.isTab && this.registerTab) {
				this.registerTab(this)
			}
		},
		tryUnregisterTab() {
			if (this.isTab && this.unregisterTab) {
				this.unregisterTab(this)
			}
		},

	},

	computed: {
		dataManager(){
			return this.dataManagerProp || CommonObject.dataManager
		},

		isLoggedIn(){
			return this.$authManager.isLoggedIn()
		},
		timezoneComputed() {
			return userTimezone()
		},
		attrsStylesClass() {
			let {style, class: clazz} = this.$attrs
			return {style, class: clazz}
		},
		attrsNoStylesClass() {
			let {style, class: clazz, ...rest} = this.$attrs
			return {...rest}
		},
		attrsVue2(){
			let attrs = {...this.attrsNoListeners}
			delete attrs.style
			delete attrs.class
			return attrs
		},
		attrsNoListeners() {
			let attrs = {...this.$attrs}
			for (let key in attrs) {
				if (key.match(/^on[A-Z]/)) {
					// console.log("attrNoListeners: removing key = ", key)
					delete attrs[key]
				}
			}
			return attrs
		},
		attrsListenersOnly() {
			let attrs = {}
			for (let key in this.$attrs) {
				if (key.match(/^on[A-Z]/)) {
					attrs[key] = this.$attrs[key]
				}
			}
			return attrs
		},

	},
}
</script>

<style lang="scss">

</style>
